<template>
  <main>
    <span
      v-if="transactionDetails.source === 'market' && accessLevel === 'admin'"
    >
      <small
        v-if="transactionDetails.fulfilled && transactionDetails.received"
        class="cursor-pointer text-primary"
        @click="showPopup = true"
      >
        View Receipt
      </small>
      <small
        v-else
        class="cursor-pointer text-primary"
        @click="showPopup = true"
      >
        Action pending
      </small>
    </span>
    <small
      v-else-if="transactionDetails.source !== 'market'"
      class="cursor-pointer text-primary"
      @click="showPopup = true"
    >
      View Receipt
    </small>
    <small v-else class="cursor-pointer text-primary" @click="showPopup = true">
      View order
    </small>
    <vs-popup
      ref="transactionDetailsRef"
      title="Load Details"
      :active.sync="showPopup"
    >
      <div class="vx-row mx-10">
        <vx-card class="overflow-hidden mb-4">
          <p class="text-xs">TO</p>
          <div class="flex items-center pb-5">
            <!-- <vs-avatar
              size="48px"
              src="https://avatars2.githubusercontent.com/u/31676496?s=460&v=4"
              alt="profile-img"
            /> -->

            <vs-avatar
              v-if="
                transactionDetails.linkedUserData &&
                transactionDetails.linkedUserData.profilePictureUrl
              "
              size="48px"
              :src="
                constants.s3Bucket +
                '/editor/profile-pictures/' +
                transactionDetails.linkedUserData.profilePictureUrl
              "
              alt="profile-img"
            />
            <vs-avatar
              v-else
              class="profile-picture"
              size="48px"
              :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                transactionDetails.linkedUserData
                  ? transactionDetails.linkedUserData.firstName
                  : '' || 'boringAvatar',
                transactionDetails.linkedUserData
                  ? transactionDetails.linkedUserData.lastName
                  : '' || 'boringAvatar'
              )}`"
            />

            <div class="details ml-4 text-left">
              <h4 class="name text-black font-bold text-lg">
                {{
                  transactionDetails.linkedUserData
                    ? transactionDetails.linkedUserData.firstName
                    : ""
                }}{{ " "
                }}{{
                  transactionDetails.linkedUserData
                    ? transactionDetails.linkedUserData.lastName
                    : ""
                }}
              </h4>
              <p class="email">
                {{
                  transactionDetails.linkedUserData
                    ? transactionDetails.linkedUserData.email
                    : ""
                }}
              </p>
            </div>
          </div>
          <p class="text-sm">
            Board:
            <span class="text-black font-medium uppercase">{{
              transactionDetails.source
            }}</span>
          </p>
        </vx-card>
        <div
          v-if="transactionDetails.source === 'market'"
          class="table-container w-full overflow-hidden"
        >
          <vs-table :data="[transactionDetails]">
            <template slot="thead">
              <vs-th> Product </vs-th>
              <vs-th> Quantity </vs-th>
              <vs-th> Date </vs-th>
              <vs-th> UNIT PRICE </vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td
                  class="text-black"
                  :data="data[indextr].product_details.product_name"
                >
                  {{ data[indextr].product_details.product_name }}
                </vs-td>

                <vs-td class="text-black" :data="data[indextr].qty">
                  {{ data[indextr].qty }}
                </vs-td>

                <vs-td class="text-black" :data="data[indextr].updatedAt">
                  {{ data[indextr].updatedAt.split("T")[0] }}
                </vs-td>

                <vs-td
                  class="text-black"
                  :data="data[indextr].product_details.product_price"
                >
                  {{
                    orgPriceTypes.filter(
                      (price) =>
                        price.key.toString() ===
                        data[
                          indextr
                        ].product_details.product_price_type.toString()
                    )[0].label
                  }}
                  {{ " " }}
                  {{ data[indextr].product_details.product_price }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div v-else class="table-container w-full overflow-hidden">
          <vs-table :data="[transactionDetails]">
            <template slot="thead">
              <vs-th> APP </vs-th>
              <vs-th> Reference ID </vs-th>
              <vs-th> Date </vs-th>
              <vs-th> AMOUNT </vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="text-black" :data="data[indextr].apps">
                  {{ data[indextr].apps }}
                </vs-td>

                <vs-td class="text-black" :data="data[indextr].referenceId">
                  {{ data[indextr].referenceId }}
                </vs-td>

                <vs-td class="text-black" :data="data[indextr].updatedAt">
                  {{ data[indextr].updatedAt.split("T")[0] || "" }}
                </vs-td>

                <vs-td class="text-black" :data="data[indextr].amount">
                  €{{ data[indextr].amount }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <!-- <vx-card
          v-if="transactionDetails.source !== 'market'"
          class="overflow-hidden mb-4"
        >
          <div class="text-sm flex items-center justify-between mb-3">
            <p>Subtotal</p>
            <p class="text-black font-medium">$2.35</p>
          </div>
          <div class="text-sm flex items-center justify-between mb-3">
            <p>Discount</p>
            <p class="text-black font-medium">$0.35</p>
          </div>
          <div class="text-sm flex items-center justify-between mb-3">
            <p>TAX</p>
            <p class="text-black font-medium">$0.10</p>
          </div>
          <hr class="divider" />
          <div class="flex items-center justify-between mt-3">
            <h5 class="total">GRAND TOTAL</h5>
            <div class="flex gap-x-1">
              <span v-if="!isNaN(parseFloat(transactionDetails.currency))">
                {{
                  orgPriceTypes.filter(
                    (price) =>
                      price.key.toString() ===
                      transactionDetails.currency.toString()
                  )[0].label
                }}
              </span>
              <span v-else> € </span>
              <span>{{ transactionDetails.amount }}</span>
            </div>
          </div>
        </vx-card> -->
        <vx-card v-if="transactionDetails.source === 'market'" class="mb-4">
          <div
            v-if="transactionDetails.product_details.isMintable === 'true'"
            class="flex gap-x-2 flex-wrap"
          >
            <span class="text-black font-bold">Wallet Address:</span>
            <span>{{ transactionDetails.walletAddress }} </span>
          </div>
          <div
            v-else-if="transactionDetails.address.address !== ''"
            class="flex gap-x-2 flex-wrap"
          >
            <span class="text-black font-bold">Address:</span>
            <span
              >{{
                transactionDetails.address
                  ? transactionDetails.address.appartment
                  : ""
              }}
              {{
                transactionDetails.address
                  ? transactionDetails.address.address
                  : ""
              }}
              {{
                transactionDetails.address
                  ? transactionDetails.address.appartment
                  : ""
              }}
              {{
                transactionDetails.address
                  ? transactionDetails.address.city
                  : ""
              }}
              {{
                transactionDetails.address
                  ? transactionDetails.address.state
                  : ""
              }},
              {{
                transactionDetails.address
                  ? transactionDetails.address.pinCode
                  : ""
              }}
            </span>
          </div>
          <div v-else class="flex gap-x-2 flex-wrap">
            <span class="text-black font-bold">Address:</span>
            <span
              >Shipping not enabled. Arrange with
              {{
                transactionDetails.linkedUserData
                  ? transactionDetails.linkedUserData.firstName
                  : ""
              }}{{ " "
              }}{{
                transactionDetails.linkedUserData
                  ? transactionDetails.linkedUserData.lastName
                  : ""
              }}
              to fulfil claim.
            </span>
          </div>
        </vx-card>
        <vx-card class="overflow-hidden mb-4">
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <p class="mb-2 text-sm text-black">Organisation Address</p>
              <p v-if="orgData.location !== undefined" class="sign text-sm">
                {{ orgData.location }}
              </p>
              <p v-else class="sign text-black"></p>
            </div>
            <div class="vx-col w-1/2">
              <p
                v-if="transactionDetails.source === 'market'"
                class="mb-2 text-sm text-black"
              >
                For more info on product
              </p>
              <p v-else class="mb-2 text-sm text-black">For more info</p>
              <p class="truncate link cursor-pointer">
                Visit:
                <a class="link" @click="navigateToMarket()"
                  >getboarded.com/organization/{{
                    orgData.slug
                  }}/marketplace/config/marketapp</a
                >
              </p>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row">
        <vx-card class="overflow-hidden px-10">
          <div class="flex justify-between px-4">
            <div class="price-bottom">
              <div class="flex gap-x-1 mb-2 text-xl font-semibold text-black">
                <span v-if="!isNaN(parseFloat(transactionDetails.currency))">
                  {{
                    orgPriceTypes.filter(
                      (price) => price.key == transactionDetails.currency
                    )[0]
                      ? orgPriceTypes.filter(
                          (price) => price.key == transactionDetails.currency
                        )[0].label || ""
                      : ""
                  }}
                </span>
                <span v-else> € </span>
                <span>{{
                  transactionDetails.amount * (transactionDetails.qty || 1)
                }}</span>
              </div>
              <h5 class="text-sm">{{ transactionDetails.remark }}</h5>
            </div>
            <div>
              <button
                @click="fulfillOrder()"
                class="btn-bottom cursor-pointer text-white border-none"
                v-if="
                  transactionDetails.source === 'market' &&
                  !transactionDetails.fulfilled &&
                  accessLevel === 'admin'
                "
              >
                Fulfill Order
              </button>
              <button
                @click="orderReceived()"
                class="btn-bottom cursor-pointer text-white border-none"
                v-else-if="
                  transactionDetails.source === 'market' &&
                  transactionDetails.fulfilled &&
                  transactionDetails.received === null &&
                  accessLevel === 'user'
                "
              >
                Order Received
              </button>

              <button
                @click="downloadDetails()"
                class="btn-bottom cursor-pointer text-white border-none"
                v-else-if="
                  transactionDetails.source === 'market' &&
                  transactionDetails.fulfilled
                "
              >
                Download
              </button>
            </div>
          </div>
        </vx-card>
      </div>
    </vs-popup>
  </main>
</template>

<script>
import constants from "@/constants";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
export default {
  components: {},
  props: {
    accessLevel: String,
    transactionDetails: {
      type: Object,
      default: () => {},
    },
    fetchTransactions: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    orgPriceTypes() {
      return this.$store.state.market.orgPriceTypes;
    },
    orgProductTypes() {
      return this.$store.state.market.orgProductTypes;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  data() {
    return {
      constants,
      showPopup: false,
      userData: [
        {
          apps: "Resume Parser",
          refId: "xafkmggf",
          date: "5",
          subtotal: "2.35",
        },
        {
          apps: "Resume Editor",
          refId: "xaggfnyf",
          date: "9",
          subtotal: "00.00",
        },
        {
          apps: "Resume Parser",
          refId: "xafgydyf",
          date: "1",
          subtotal: "5",
        },
      ],
    };
  },
  methods: {
    navigateToMarket() {
      const dynamicMarketRoute = `/organization/${this.orgData.slug}/marketplace/config/marketapp`;
      this.$router.push(dynamicMarketRoute);
    },
    downloadDetails() {
      this.generatePDF(this.transactionDetails);
    },
    async generatePDF(txDetails) {
      const pdfName = `Order-Details-${txDetails.linkedUserData.firstName}.pdf`;
      const vsLoading = this.$vs.loading;

      await html2canvas(this.$refs.transactionDetailsRef.$el).then(function (
        canvas
      ) {
        var a = document.createElement("a");
        // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
        a.href = canvas.toDataURL("image/jpeg", 1.0);
        a.download = `Order-Details-${txDetails.linkedUserData.firstName}.jpeg`;
        a.click();

        const img = new Image();
        img.onload = async function () {
          // // console.log(this.width + 'x' + this.height);
          let pdf = new jsPDF("p", "px", [this.width, this.height]);
          if (this.width > this.height) {
            pdf = new jsPDF("l", "px", [this.width, this.height]);
          }
          await pdf.addImage(a.href, "JPEG", 0, 0, this.width, this.height);
          await pdf.save(pdfName);
          vsLoading.close();
        };
        img.src = a.href;
      });
    },
    fulfillOrder() {
      this.$vs.loading();
      this.$store
        .dispatch("market/fulfillOrder", {
          logId: this.transactionDetails._id,
          orgId: this.orgData._id,
          userId: this.transactionDetails.linkedUserData._id,
        })
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Order fulfilled successfully",
            color: "success",
            // position: "top-right",
          });
          this.fetchTransactions();
          this.showPopup = false;
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "Error fulfilling order.",
            color: "danger",
            // position: "top-right",
          });
        });
    },
    orderReceived() {
      this.$vs.loading();
      this.$store
        .dispatch("market/receivedOrder", {
          orgId: this.transactionDetails.organizationId,
          userId: this.transactionDetails.linkedUserData._id,
          logId: this.transactionDetails._id,
        })
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Order received successfully",
            color: "success",
          });
          this.fetchTransactions();
          this.showPopup = false;
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "Error receiving order.",
            color: "danger",
          });
        });
    },
  },
};
</script>

<style scoped>
.table-container {
  box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
  background: #fff;
  border-radius: 0.5rem;
}
.btn-bottom {
  background: #f2c046;
  border-radius: 1.7rem !important;
  padding: 1rem 2rem;
}
.link {
  color: #3b72ed;
}
.total {
  color: #12b76a;
}
.divider {
  margin: 0 -20px;
}
.con-vs-popup >>> .vs-popup--content {
  padding-bottom: 0 !important;
}
</style>
